<script setup lang="ts">
  import { computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { Avatar, Text } from "@ui-kit";
  import { useSettingsStore } from "@src/store";
  import { useProfileOptions } from "@src/hooks";

  const emit = defineEmits<{ (e: "click"): void }>();

  const { profile } = useProfileOptions();
  const settingsStore = useSettingsStore();
  const { t } = useI18n();

  const locationTitle = computed(() => {
    if (settingsStore.location === "store") {
      return t("склад");
    }

    if (settingsStore.location === "shopfloor") {
      return t("зал");
    }

    return settingsStore.location;
  });
</script>

<template>
  <div class="main-page-avatar" @click="emit('click')">
    <Avatar
      :first-name="profile?.current_user.first_name"
      :last-name="profile?.current_user.last_name"
      size="m"
      data-testid="main-page-user-info-btn"
    />
    <div class="main-page-avatar__store">
      <div class="main-page-avatar__store-badge">
        <Text font="body-medium-10" color="white">{{ locationTitle }}</Text>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .main-page-avatar {
    width: 48px;
    height: 48px;
    padding: 4px 0 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }

  .main-page-avatar__store {
    z-index: 1;
    display: flex;
    justify-content: center;
    padding-top: 2px;
    background-color: var(--sf-base-background-primary);
  }

  .main-page-avatar__store-badge {
    display: flex;
    justify-content: center;
    min-width: 36px;
    padding: 1px 3px;
    border-radius: 4px;
    background-color: var(--sf-base-background-dark);
  }
</style>
